/*----------------------------------------------------------------------------
|
|   A nodejs re-implementation for frontend/SecureValue.tcl :
|
|   A simple way expose and retrieve unmodifiable data, time boxed 
|   for 2 hours
|
|
|   written by Jochen Loewer
|   Dec 2015 / Feb 2018
|
\---------------------------------------------------------------------------*/

var crypto = require("crypto");


var AESKey = Buffer.from("ffc7405089482444e938fa5cfed8b486b0d229f4c00ef8902ba00004800358de","hex");
var IV     = Buffer.from("00000000000000000000000000000000","hex");


module.exports.Set = function(value) {

    
    var cipher = crypto.createCipheriv('aes-256-cbc', AESKey, IV);
    
    var payload = value + ":::" + parseInt(Date.now()/1000);
    
    return cipher.update(payload, 'utf8', 'hex') + cipher.final('hex');

}

module.exports.Get = function(value) {
    
    var decipher = crypto.createDecipheriv('aes-256-cbc', AESKey, IV);
    
    var decrypted =  decipher.update(value, 'hex','utf8') + decipher.final('utf8');    
    
    var part = decrypted.match(/^(.*):::([0-9]*)$/);
    
    if (part != null) {
        var now = Date.now()/1000;
        var timeStamp = parseInt(part[2]);
        if ( (now - timeStamp) > 7200) {
            throw "expired SecureValue container!"              
        }    
        if ( (now - timeStamp) < 0 ) {
            throw "invalid SecureValue container!"              
        }
        return part[1];
        
    }
    throw "not a valid SecureValue container!"        
}

        
